import React, { useState, useEffect } from 'react';

interface SessionWarningProps {
  expiryTime: number; // milliseconds
  onRefresh: () => void;
}

const SessionWarning: React.FC<SessionWarningProps> = ({ expiryTime, onRefresh }) => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const checkExpiry = () => {
      const now = Date.now();
      const remaining = expiryTime - now;

      if (remaining <= 0) {
        setShowWarning(false);
        return;
      }

      // Show warning 5 minutes before expiry
      if (remaining <= 5 * 60 * 1000) {
        setShowWarning(true);
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        setTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`);
      }
    };

    checkExpiry();
    const interval = setInterval(checkExpiry, 1000);

    return () => clearInterval(interval);
  }, [expiryTime]);

  if (!showWarning) return null;

  return (
    <div className="fixed top-4 right-4 left-4 md:left-auto md:w-96 bg-yellow-50 border-2 border-yellow-400 rounded-xl shadow-lg p-4 z-50 animate-slide-down">
      <div className="flex items-start gap-3">
        <svg className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <div className="flex-1">
          <h3 className="font-bold text-yellow-900 mb-1">ההתחברות עומדת לפוג</h3>
          <p className="text-sm text-yellow-800 mb-2">
            הסשן שלך יפוג בעוד <span className="font-mono font-bold">{timeLeft}</span>
          </p>
          <button
            onClick={onRefresh}
            className="w-full px-4 py-2 bg-yellow-600 hover:bg-yellow-700 text-white rounded-lg font-medium transition-colors"
          >
            התחבר מחדש
          </button>
        </div>
        <button
          onClick={() => setShowWarning(false)}
          className="text-yellow-600 hover:text-yellow-800"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SessionWarning;
